module.exports = __webpack_public_path__ + "static/media/cardiology_header.a0e20497.svg";